require('./webp-check');
require('./modals');
require('./popup');
require('./stripeButton');
require('./contactForm');

const externalLinks = () => {
    const anchors = document.querySelectorAll('a');

    for (let i = 0; i < anchors.length; i++) {
        if (anchors[i].hostname !== window.location.hostname) {
            anchors[i].setAttribute('target', '_blank');
        }
    }
};

externalLinks();

if (document.querySelector('.date-picker')) {
    const initDatePicker = () => {
        document.querySelectorAll('.date-picker').forEach((el) => {
            el.type = 'text';

            new Pikaday({
                field: el,
                theme: 'dark-theme',
                format: 'YYYY-MM-DD',
                toString(date, format) {
                    const day = date.getDate();
                    const month = date.getMonth() + 1;
                    const year = date.getFullYear();
                    return `${month}/${day}/${year}`;
                },
            });
        });
    };

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/pikaday/pikaday.js';
    script.onload = initDatePicker;

    document.body.appendChild(script);

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = 'https://cdn.jsdelivr.net/npm/pikaday/css/pikaday.css';

    document.head.appendChild(link);
}
